// src/components/CapoOfficina/CapoOfficinaTimekeeping.jsx
// Riutilizza il componente ResponsabileTimekeeping (stesso comportamento)
import ResponsabileTimekeeping from '../Responsabile/ResponsabileTimekeeping';

const CapoOfficinaTimekeeping = () => {
  return <ResponsabileTimekeeping />;
};

export default CapoOfficinaTimekeeping;